import { all, fork } from 'redux-saga/effects';
import { watchAddTaskBelowProjectTemplateSaga, watchAddTaskAboveProjectTemplateSaga } from './add-task-above-below';
import { watchCreateTaskInTemplateSagaSaga } from './create';
import { watchDeleteTaskInProjectTemplateSaga } from './delete';
import { watchAddTemplateTaskDependencySaga } from './dependency';
import { watchRearrangeTaskInProjectTemplateSaga } from './rearrange';
import { watchUpdateTaskInProjectTemplateSaga } from './update';
export function* taskTemplateRootSaga() {
    yield all([
        fork(watchCreateTaskInTemplateSagaSaga),
        fork(watchUpdateTaskInProjectTemplateSaga),
        fork(watchDeleteTaskInProjectTemplateSaga),
        fork(watchAddTaskBelowProjectTemplateSaga),
        fork(watchAddTaskAboveProjectTemplateSaga),
        fork(watchAddTemplateTaskDependencySaga),
        fork(watchRearrangeTaskInProjectTemplateSaga)
    ]);
}
